module.exports = __webpack_public_path__ + "img/kr-product-final-card3-leftTop-img.54aa3cb.png";